import React from 'react';
import { Skeleton } from '@execonline-inc/execonline-ui';

const ProgramOverviewSkeleton: React.FC = () => (
  <div className="mb-10 rounded bg-white px-5 py-6 shadow">
    {/* CURRENT label */}
    <Skeleton variant="text" size="sm" className="mb-3" style={{ width: '80px', height: '14px' }} />

    {/* Program title with Overview button */}
    <div className="mb-6 flex items-center gap-3">
      <Skeleton variant="text" size="lg" style={{ width: '280px', height: '28px' }} />
      <Skeleton
        variant="rectangle"
        style={{ width: '90px', height: '32px', borderRadius: '4px' }}
      />
    </div>

    {/* Progress section */}
    <div className="mb-6">
      <Skeleton
        variant="text"
        size="sm"
        className="mb-2"
        style={{ width: '80px', height: '14px' }}
      />
      <Skeleton variant="text" size="xl" style={{ width: '100px', height: '36px' }} />
    </div>

    {/* Resume button and What's Next section */}
    <div className="flex items-start gap-4">
      <Skeleton
        variant="rectangle"
        style={{ width: '120px', height: '40px', borderRadius: '4px' }}
      />
      <div className="flex-1">
        <Skeleton
          variant="text"
          size="sm"
          className="mb-2"
          style={{ width: '100px', height: '14px' }}
        />
        <Skeleton variant="text" size="md" style={{ width: '180px', height: '18px' }} />
        <Skeleton
          variant="text"
          size="md"
          className="mt-1"
          style={{ width: '120px', height: '18px' }}
        />
      </div>
    </div>
  </div>
);

export default ProgramOverviewSkeleton;
